import {
  ActionCenterView,
  ActionCenterInboxView,
  ActionCenterTasksView,
  ActionCenterSnoozedView,
  ActionCenterDismissedView,
  ActionCenterCompletedView,
} from './views';

const routes = [
  {
    name: 'action-center',
    path: '/advisor/action-center',
    component: ActionCenterView,
    children: [
      {
        name: 'action-center-inbox',
        path: 'inbox',
        component: ActionCenterInboxView,
      },
      {
        name: 'action-center-tasks',
        path: 'tasks',
        component: ActionCenterTasksView,
      },
      {
        name: 'action-center-snoozed',
        path: 'snoozed',
        component: ActionCenterSnoozedView,
      },
      {
        name: 'action-center-dismissed',
        path: 'dismissed',
        component: ActionCenterDismissedView,
      },
      {
        name: 'action-center-completed',
        path: 'completed',
        component: ActionCenterCompletedView,
      },
    ],
  },
];

export default routes;
